import { withInstall } from '../../../utils/with-install'
import BezierCurve from './BezierCurve.vue'

export const ElAmapBezierCurve = withInstall(BezierCurve)
export default ElAmapBezierCurve
